import { errorToast } from 'common/components/toast';
import { performRequest } from 'common/utils/performRequest';

export async function updateProperty(data) {
  try {
    const response = await performRequest(
      'put',
      `/api/content/dashboard/property-details`,
      {},
      data
    );

    return response;
  } catch (error) {
    const msg = error.response?.data?.message || 'Error';
    errorToast(msg);
  }
}

export async function getPreviewOnSaveAndPublish(brand, pid) {
  try {
    const { data } = await performRequest(
      'get',
      `/api/content/v2/publish/preview/${brand}/${pid}/en`,
      {}
    );

    if (data?.code === 500 || data?.status === 'FAILURE') {
      throw data;
    }

    return data;
  } catch (error) {
    const msg =
      error.response?.data?.message || 'Error occured while previewing';
    errorToast(msg);
  }
}

export async function contentPublish(brand, pid) {
  try {
    const { data } = await performRequest(
      'post',
      `/api/content/publish`,
      {},
      {
        brand,
        pid
      }
    );

    return data;
  } catch (error) {
    errorToast(error.message);
  }
}

export async function getContentPublishStatus(brand, pid) {
  try {
    const { data } = await performRequest(
      'get',
      `/api/content/publish/status/${brand}/${pid}/en`,
      {}
    );

    return data;
  } catch (error) {
    errorToast(error.message);
  }
}

export async function createProperty(form) {
  try {
    const { data } = await performRequest(
      'post',
      `/api/content/dashboard/property-details`,
      {},
      form
    );

    return data;
  } catch (error) {
    const msg = error.response?.data?.message || 'Error';
    errorToast(msg);
  }
}

export async function getHotelList(brand) {
  try {
    const { data } = await performRequest(
      'get',
      `/api/content/properties/${brand}/en`,
      {}
    );

    return data;
  } catch (err) {
    errorToast(err.message);
  }
}

export async function createDuplicateHotel(brand, pid) {
  try {
    const { data } = await performRequest(
      'get',
      `/api/content/dashboard/properties/duplicate/${brand}/${pid}`,
      {}
    );

    return data;
  } catch (err) {
    errorToast(err.message);
  }
}

export async function getAttributes() {
  try {
    const response = await performRequest(
      'get',
      `/api/content/master/attributes`,
      {}
    );

    // Check if response contains data before destructuring
    if (response && response.data) {
      const { data } = response;
      return data;
    } else {
      // Handle the case where data is undefined or missing in the response
      console.error('Data is undefined or missing in the response.');
      // You may choose to return null or throw an error here
      return null;
    }
  } catch (err) {
    errorToast(err.message);
  }
}

// Helper function to build field path
const buildFieldPath = fieldData => {
  const { code, sectionName, nodeText } = fieldData;

  if (sectionName === 'amenities') {
    return `${sectionName}.${nodeText}.code_${code}.active`
  }

  return `${sectionName}.code_${code}.active`;
};

// Helper function to transform API response to usable format
export const transformApiResponseToConnections = apiResponse => {
  if (!apiResponse || !Array.isArray(apiResponse)) return [];
  return apiResponse.map(item => ({
    sourceField: buildFieldPath(item.sourceField),
    targetFields: item.targetFields.map(target => buildFieldPath(target)),
  }));
};

export const getDependentFields = async () => {
  try {
    const response = await performRequest(
      'get',
      `/api/content/master/dependent-codes`,
      {}
    );

    // Transform the response using the helper function
    const transformedResponse = transformApiResponseToConnections(
      response.data
    );
    return transformedResponse;
  } catch (error) {
    console.error('Error fetching dependent fields:', error);
    throw error;
  }
};
